// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel---vo6b3","totalRecordsLabel":"totalRecordsLabel---Q48OI"};